export enum RichTextEditorButton {
  ALIGN_CENTER = 'ALIGN_CENTER',
  ALIGN_LEFT = 'ALIGN_LEFT',
  ALIGN_RIGHT = 'ALIGN_RIGHT',
  BOLD = 'BOLD',
  BULLETED_LIST = 'BULLETED_LIST',
  ITALIC = 'ITALIC',
  NUMBERED_LIST = 'NUMBERED_LIST',
  SET_LINK = 'SET_LINK',
  STRIKETHROUGH = 'STRIKETHROUGH',
  UNDERLINE = 'UNDERLINE',
  UNSET_LINK = 'UNSET_LINK',
}

export enum RichTextEditorUIElement {
  VERTICAL_SEPARATOR = 'VERTICAL_SEPARATOR',
}

export enum RichTextEditorSelect {
  TEXT_STYLE = 'TEXT_STYLE',
}

export enum RichTextEditorTextStyle {
  NORMAL = 'NORMAL',
  H2 = 'H2',
  H3 = 'H3',
}

export enum RichTextEditorCustomItem {
  FOOTNOTE = 'FOOTNOTE',
  HIGHLIGHT = 'HIGHLIGHT',
  HOTLINE_CTA = 'HOTLINE_CTA',
  VARIABLES = 'VARIABLES',
}
